import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
const container = {
    position: 'absolute',
    fontsize: 8,
    padding: '5px',
};
/**
 * Shows the current version based on the variable VERSION which gets injected through WebPack.
 * @constructor
 */
export const ApplicationVersion = (props) => {
    const getVersion = () => {
        let versionToDisplay = 'unknown';
        try {
            versionToDisplay = `v${VERSION} - ${SHORT} on ${BRANCH}`;
            console.info(versionToDisplay);
        }
        catch (error) {
            console.info('Cannot get version of application.');
        }
        return versionToDisplay;
    };
    useEffect(() => {
        getVersion();
    }, []);
    const shouldShow = () => props.applicationVersionService.isLocationWhiteListed();
    if (!shouldShow()) {
        return _jsx(_Fragment, {});
    }
    return _jsx(_Fragment, {});
};
export default ApplicationVersion;
//# sourceMappingURL=ApplicationVersion.js.map